import { useRef, useState, useEffect } from 'react';
import { Heading, Text, Button } from '../../atoms';
import { useLanguage } from '../../../context/LanguageContext';
import './ContactSection.css';

function ContactSection() {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth < 768;
  });
  const sectionRef = useRef(null);

  useEffect(() => {
    if (isVisible) return;
    const el = sectionRef.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <section
      id="contact"
      ref={sectionRef}
      className={`contact-section ${isVisible ? 'contact-section--visible' : ''}`}
    >
      <div className="contact-section__inner">
        <span className="contact-section__label-top">{t('contact.label')}</span>
        <Heading level={2} className="contact-section__title">{t('contact.title')}</Heading>
        <Text size="large" className="contact-section__intro">
          {t('contact.intro')}
        </Text>

        <div className="contact-section__whatsapp-wrap">
          <a
            href="https://wa.me/5491132361805"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-section__whatsapp"
          >
            <span className="contact-section__whatsapp-icon-wrap">
              <img src="/img/whatsapp.png" alt="" className="contact-section__whatsapp-icon" />
            </span>
            <span className="contact-section__whatsapp-text">
              <strong>{t('contact.whatsapp')}</strong>
              <em>{t('contact.whatsappSub')}</em>
            </span>
          </a>
        </div>

        <div className="contact-section__grid">
          <div className="contact-section__info">
            <div className="contact-section__item">
              <strong>{t('contact.phone')}</strong>
              <p><a href="tel:+5491132361805">9 11 3236-1805</a></p>
            </div>
            <div className="contact-section__item">
              <strong>{t('contact.hours')}</strong>
              <p>{t('contact.hoursValue')}</p>
            </div>
          </div>
          <form className="contact-section__form" action="https://formspree.io/f/xreyolap"
            method="POST">
            <label className="contact-section__label">
              {t('contact.nameLabel')}
              <input type="text" name="name" className="contact-section__input" required placeholder={t('contact.formName')} />
            </label>
            <label className="contact-section__label">
              {t('contact.emailLabel')}
              <input type="email" name="email" className="contact-section__input" required placeholder={t('contact.formEmail')} />
            </label>
            <label className="contact-section__label">
              {t('contact.messageLabel')}
              <textarea name="message" className="contact-section__input contact-section__textarea" rows={5} required placeholder={t('contact.formMessage')} />
            </label>
            <Button type="submit" variant="primary">{t('contact.sendMessage')}</Button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
